export function VisibilityHelper(id,visibility){
    const element = document.getElementById(id);
    if (element) {
      if(visibility){
        element.style.display = "block";
      }else{
        element.style.display = "none";
      }
    }
}